import { render, staticRenderFns } from "./videoListJg.vue?vue&type=template&id=be9afa08&scoped=true"
import script from "./videoListJg.vue?vue&type=script&lang=js"
export * from "./videoListJg.vue?vue&type=script&lang=js"
import style0 from "./videoListJg.vue?vue&type=style&index=0&id=be9afa08&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be9afa08",
  null
  
)

export default component.exports